module.exports = __webpack_public_path__ + "img/img1.2684e2a8.png";